// extracted by mini-css-extract-plugin
module.exports = {"container":"how-it-works-main_container___DsPl"};